
import { Vue, Component, Prop } from 'vue-property-decorator';

import { Company, User, Payment_Card } from '@/generated/graphql';

import ModalFullScreen from '@/components/modal/ModalFullScreen.vue';
import UiButton from '@/components/button/ui-button.vue';

import InfoIcon from '@/components/icons/CancelInfoIcon.vue';

import GET_PAYMENT_CARDS_ESSENTIAL from '@/apollo/payment/GetPaymentCardsEssential.gql';

@Component({
	components: {
		ModalFullScreen,
		UiButton,
		InfoIcon,
	},
})
export default class AddSubscription extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Boolean, required: true }) readonly isLoading: boolean;

	paymentDetails: Payment_Card | null = null;

	created() {
		this.$apollo
			.query({
				query: GET_PAYMENT_CARDS_ESSENTIAL,
				variables: {
					userId: this.currentUser.id,
				},
				fetchPolicy: 'network-only',
			})
			.then((result) => {
				const payment: Payment_Card = result.data.payment_card[0];
				this.paymentDetails = {
					...payment,
				};
			})
			.catch(console.error);
	}
}
